import React, { useState } from 'react';
import { supabase } from './supabaseClient';
import { t } from './i18n';
import { invitaCont } from './invitatie';

// ============================================================
// Contul unui client EXISTENT (24 septembrie 2026, Etapa 8, pasul 1b).
//
// Pana acum contul de client se facea doar odata cu clientul, din „+ Client nou". Un client
// adus altfel (Dan Neicu, creat prin SQL pe 16 septembrie) n-avea nicio cale prin interfata:
// contul de recenzor TikTok s-a legat de mana, din panoul Supabase.
//
// Din 9 octombrie 2026 contul se face pe server, prin `invita-cont` (acelasi drum ca la
// „+ Client nou" si la „Echipa"): pleaca mailul „Invite user", cu textul invitatiei
// (`supabase/email/confirmare_invitatie.html`). Omul apasa, App.js prinde `type=invite` si il
// duce la alegerea parolei. Pana atunci contul se facea din browser, cu `signUp`.
//
// Drepturile NU se aleg aici: stau pe client (`permisiuni_client`) si le primeste orice cont
// legat de el.
// ============================================================

export default function InvitaContClient({ client, onInchide, onInvitat }) {
  const [email, setEmail] = useState(client.email || '');
  const [seTrimite, setSeTrimite] = useState(false);
  const [eroare, setEroare] = useState('');

  async function trimite() {
    const adresa = email.trim().toLowerCase();
    if (!adresa) return;
    setSeTrimite(true);
    setEroare('');

    // Contul, profilul si legatura cu clientul se fac pe server, intr-un singur pas
    // (`invita-cont`, 9 octombrie 2026). O adresa care are deja cont e refuzata acolo.
    const invitatie = await invitaCont({ email: adresa, nume: client.nume, rol: 'client', clientId: client.id });
    if (!invitatie.ok) {
      setSeTrimite(false);
      setEroare(invitatie.mesaj);
      return;
    }

    // Adresa intra si in fisa clientului, dar doar daca fisa n-avea una: la Gaga, de pilda,
    // adresa din fisa e alta decat cea de intrare, si nu se calca.
    if (!client.email) {
      await supabase.from('clienti').update({ email: adresa }).eq('id', client.id);
    }

    setSeTrimite(false);
    if (onInvitat) onInvitat(adresa);
    onInchide();
    alert(t('clienti', 'invitaTrimisa', { email: adresa }));
  }

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h2 className="modal-titlu">{t('clienti', 'invitaTitlu', { nume: client.nume })}</h2>
        <p style={{ fontSize: 13, color: '#374151', marginTop: 0 }}>{t('clienti', 'invitaExplicatie')}</p>
        <div className="modal-camp">
          <label className="label">{t('clienti', 'email')}</label>
          <input
            type="email"
            className="select-input"
            placeholder={t('clienti', 'emailPlaceholder')}
            value={email}
            disabled={seTrimite}
            onChange={e => setEmail(e.target.value)}
          />
        </div>
        {eroare && <p style={{ color: '#B91C1C', fontSize: 13 }}>{eroare}</p>}
        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
          <button type="button" className="btn-secundar" onClick={onInchide} disabled={seTrimite}>{t('clienti', 'anuleaza')}</button>
          <button type="button" className="btn-principal" onClick={trimite} disabled={seTrimite || !email.trim()}>
            {seTrimite ? t('clienti', 'invitaSeTrimite') : t('clienti', 'invitaTrimite')}
          </button>
        </div>
      </div>
    </div>
  );
}
